import React, { useEffect, useState } from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import style from '../styles/lifehack.module.scss'
import { GxIcon } from '@garpix/garpix-web-components-react'
import { arrowRightIcon } from '@/images'
import { useModal } from '@/hooks'
import SliderContainer from '@/components/Container/SliderContainer'
import { api } from '@/api'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'

SwiperCore.use([Navigation])

const LifeHacks = (): React.ReactElement => {
  const { openModal } = useModal()
  const [data, setData] = useState<any[]>([])

  const handleOpenModal = (data): void => {
    openModal('lifehack', { lifehackId: data.id })
  }

  useEffect(() => {
    api.getLifeHacks()
      .then((data) => {
        setData(data.results)
      })
      .catch(error => console.log(error))
  }, [])

  return (
    <SliderContainer>
      <div className={style.slider_buttons}>
        <button className='slider_button slider_button_prev js_lifehack_prev'>
          <GxIcon src={arrowRightIcon} className={style.slider__icon} />
        </button>
        <button className='slider_button slider_button_next js_lifehack_next'>
          <GxIcon src={arrowRightIcon} className={style.slider__icon} />
        </button>
      </div>
      <Swiper
        slidesPerView='auto'
        spaceBetween={20}
        resizeObserver
        navigation={{
          prevEl: '.js_lifehack_prev',
          nextEl: '.js_lifehack_next'
        }}
        freeMode
        grabCursor
      >
        {data.length === 0
          ? (
            <>
              <SwiperSlide className={style.slider__slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
              <SwiperSlide className={style.slider__slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
              <SwiperSlide className={style.slider__slide}>
                <PlaceholderLoading shape='rect' width='100%' height='100%' />
              </SwiperSlide>
            </>
            )
          : (
              data.map((slide) => {
                return (
                  <SwiperSlide key={slide.id} className={style.slider__slide}>
                    <img
                      src={slide.preview_picture[0]}
                      width='421px'
                      height='311'
                      alt={slide.title}
                      className={style.slider__image}
                    />
                    <button
                      onClick={() => handleOpenModal(slide)}
                      title={slide.title}
                      className={style.slider__content}
                    >
                      <span className={style.slider__text}>{slide.name}</span>
                    </button>
                  </SwiperSlide>
                )
              })
            )}
      </Swiper>
    </SliderContainer>
  )
}

export default LifeHacks
